module.exports = __webpack_public_path__ + "img/191514_6D5145_4E3324_3B564D-256px.9c4d11e8.png";